import { nanoid } from 'nanoid'

export function uniqueId(): string {
  return nanoid()
}
